export type HighlightPart = { text: string; highlighted: boolean };

export function escapeRegex(word: string): string {
  return word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function highlightText(text: string, words: string[]): string | HighlightPart[] {
  const pattern = new RegExp(`(${words.map(escapeRegex).join("|")})`, "gi");
  const parts = text.split(pattern);
  if (parts.length === 1) return text;
  return parts.map((part, i) => ({ text: part, highlighted: i % 2 === 1 }));
}
